import React from 'react';
import { ShieldCheckIcon, ZapIcon, HeadphonesIcon } from 'lucide-react';
import { Card } from '../ui/Card';
import { useTranslation } from '../../lib/i18n';
export function CoreValues() {
  const {
    lang
  } = useTranslation();
  const values = lang === 'en' ? [{
    icon: ShieldCheckIcon,
    title: 'Reliability first',
    description: 'Built to withstand demanding industrial environments. Every component is tested for durability and consistent performance.'
  }, {
    icon: ZapIcon,
    title: 'Industrial power',
    description: 'Powerful 1200W motors and robust construction handle loads up to 250kg. Designed for heavy-duty applications.'
  }, {
    icon: HeadphonesIcon,
    title: 'Support & service',
    description: 'Dedicated technical support and comprehensive warranty. We stand behind our equipment with expert assistance.'
  }] : [{
    icon: ShieldCheckIcon,
    title: 'Pouzdanost na prvom mestu',
    description: 'Napravljeno da izdrži zahtevna industrijska okruženja. Svaka komponenta je testirana na izdržljivost i dosledne performanse.'
  }, {
    icon: ZapIcon,
    title: 'Industrijska snaga',
    description: 'Moćni motori od 1200W i robusna konstrukcija rukuju teretima do 250kg. Dizajnirano za teške primene.'
  }, {
    icon: HeadphonesIcon,
    title: 'Podrška i servis',
    description: 'Posvećena tehnička podrška i sveobuhvatna garancija. Stojimo iza naše opreme sa stručnom pomoći.'
  }];
  const heading = lang === 'en' ? <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-163">
        Operational stability and{' '}
        <span className="text-brand-yellow" data-id="element-164">support</span>
      </h2> : <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-165">
        Operativna stabilnost i{' '}
        <span className="text-brand-yellow" data-id="element-166">podrška</span>
      </h2>;
  const subtitle = lang === 'en' ? 'Delivery, technical support and service stability — a system designed to work, not to stand still.' : 'Isporuka, tehnička podrška i servisna stabilnost - sistem koji je dizajniran da radi, a ne da stoji.';
  return <section className="py-20 bg-dark-surface" data-id="element-167">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
        <div className="text-center mb-12" data-id="element-169">
          {heading}
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-170">{subtitle}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-171">
          {values.map(value => {
          const Icon = value.icon;
          return <Card key={value.title} data-id="element-172">
                <div className="flex flex-col items-center text-center" data-id="element-173">
                  <div className="w-16 h-16 bg-brand-yellow rounded-industrial flex items-center justify-center mb-4" data-id="element-174">
                    <Icon className="w-8 h-8 text-dark-bg" data-id="element-175" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-176">
                    {value.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-177">
                    {value.description}
                  </p>
                </div>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}